module.exports = __webpack_public_path__ + "img/uploading.a7bf3bb7.png";